/* eslint-disable no-param-reassign */
import { Dispatch, MutableRefObject, SetStateAction, useContext } from "react";
import { Box, Button, SxProps, Typography, CircularProgress } from "@mui/material";
import { SuccessAlertContext } from "App";
import { Search, HelpOutline } from "@mui/icons-material";
import { getUserType } from "util/auth";
import downloadHelpPdf from "../api/downloadHelpPdf";

type Props = {
  orderTitle: string;
  OrderTable: JSX.Element;
  HeaderBox: JSX.Element;
  isLoading: boolean;
  helpPath?: string;
};

/**
 * 注文のコンテナコンポーネント
 * @param param0 コンポーネントのプロップス
 * @returns JSX.Element
 */
export default function OrderContainer({ orderTitle, OrderTable, HeaderBox, isLoading, helpPath }: Props) {
  const { showAlert } = useContext(SuccessAlertContext);

  return (
    <Box width="90%" alignSelf="center" marginLeft="5%" minHeight={330} position="relative" pt={0}>
      { helpPath ?
        <Box width="100%" height={32} textAlign="right">
          <Button
            variant="custom-outlined"
            onClick={async (e) => {
              // apiからpdfのURLを取得
              const url = await downloadHelpPdf(`${getUserType()}${helpPath}`);
              window.open(url, "_blank", "noopener,noreferrer");
            }}
            startIcon={<HelpOutline color="secondary" />}
            sx={{ height: 24, padding: 1, marginTop: 0.5, marginRight: 1 }}
          >
            ヘルプ
          </Button>
        </Box>
        : <Box width="100%" height={32} textAlign="right" />
      }
      <Box>
        <Box position="absolute" top={32} left={0} width="100%" textAlign="center">
          <Typography fontSize={22}>{orderTitle}</Typography>
        </Box>
        {HeaderBox}
        {!isLoading && OrderTable}
        {isLoading && (
          <Box height={330} textAlign="center" alignContent="center">
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
}
